export class Note {
    id: string;
    name: string;
    emailId: string;
    message: string;
    date: Date;
}